import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { BannerBar } from './components/BannerBar';
import { HeroSection } from './components/HeroSection';
import { EarlyTestimonials } from './components/EarlyTestimonials';
import { ProblemSection } from './components/ProblemSection';
import { AuthorSection } from './components/AuthorSection';
import { ProductOverview } from './components/ProductOverview';
import { BundleVisual } from './components/BundleVisual';
import { BonusSection } from './components/BonusSection';
import { MechanismSection } from './components/MechanismSection';
import { FeaturesSection } from './components/FeaturesSection';
import { MoneyBackGuarantee } from './components/MoneyBackGuarantee';
import { TestimonialsSection } from './components/TestimonialsSection';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { CheckoutTrustElements } from './components/CheckoutTrustElements';
import { FinalCTA } from './components/FinalCTA';
import { StickyBottomCTA } from './components/StickyBottomCTA';
export function App() {
  return <div className="w-full min-h-screen bg-stone-50" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <BannerBar data-id="element-2" />
      <HeroSection data-id="element-3" />
      <div className="border-t border-stone-200" data-id="element-4"></div>
      <EarlyTestimonials data-id="element-5" />
      <div className="border-t border-stone-200" data-id="element-6"></div>
      <ProblemSection data-id="element-7" />
      <div className="border-t border-stone-200" data-id="element-8"></div>
      <AuthorSection data-id="element-9" />
      <div className="border-t border-stone-200" data-id="element-10"></div>
      <ProductOverview data-id="element-11" />
      <div className="border-t border-stone-200" data-id="element-12"></div>
      <BundleVisual data-id="element-13" />
      <div className="border-t border-stone-200" data-id="element-14"></div>
      <BonusSection data-id="element-15" />
      <div className="border-t border-stone-200" data-id="element-16"></div>
      <MechanismSection data-id="element-17" />
      <div className="border-t border-stone-200" data-id="element-18"></div>
      <FeaturesSection data-id="element-19" />
      <div className="border-t border-stone-200" data-id="element-20"></div>
      <MoneyBackGuarantee data-id="element-21" />
      <div className="border-t border-stone-200" data-id="element-22"></div>
      <TestimonialsSection data-id="element-23" />
      <div className="border-t border-stone-200" data-id="element-24"></div>
      <WhoIsThisFor data-id="element-25" />
      <div className="border-t border-stone-200" data-id="element-26"></div>
      <CheckoutTrustElements data-id="element-27" />
      <div className="border-t border-stone-200" data-id="element-28"></div>
      <FinalCTA data-id="element-29" />
      <StickyBottomCTA data-id="element-30" />
    </div>;
}